import {Injectable, signal} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NdjsonService {
  readonly records = signal<any[]>([]);
  readonly bytes = signal(0);
  readonly loading = signal(false);

  async startDownload(url: string, downloadedRecords?: (record: any) => void) {
    this.records.set([]);
    this.bytes.set(0);
    this.loading.set(true);

    try {
      await this.streamNdjson(url,
        (obj) => {
          this.records.update(r => [...r, obj.data]);
          if (downloadedRecords) {
            downloadedRecords(obj.data);
          }
        },
        (bytes) => this.bytes.set(bytes));
    } finally {
      this.loading.set(false);
    }
  }

  private async streamNdjson(url: string, onRecord: (obj: any) => void, onProgress?: (bytes: number) => void) {
    const res = await fetch(url);
    if (!res.body) {
      throw new Error("Response doesn't have a body");
    }

    const reader = res.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';
    let totalBytes = 0;

    while (true) {
      const {value, done} = await reader.read();
      if (done) break;

      totalBytes += value.length;
      onProgress?.(totalBytes);

      buffer += decoder.decode(value, {stream: true});
      const lines = buffer.split('\n');
      buffer = lines.pop() || '';

      for (const line of lines) {
        if (line.trim().length > 0) {
          const obj = JSON.parse(line);
          onRecord(obj);
        }
      }
    }
  }
}
